<template>
	<main>
		<RouterView />
	</main>
</template>

<script setup lang="ts"></script>
